<template>

  <div :class="{'box-loading': loading}">
    <div class="form-group mb-2">
      <textarea
        class="form-control"
        :placeholder="$t('Comments')"
        v-model="approval.comment"></textarea>
      <ValidateMessage
        :error="validateErrors.comment" />
    </div>
    <div class="form-group mb-3">
      <div class="btn-group d-flex">
        <button
          type="button"
          class="btn w-100"
          :class="approval.status === 'disapproved' ? 'btn-danger' : 'btn-outline-danger'"
          @click="approval.status = 'disapproved'">
          <i class="far fa-thumbs-down"></i>
          {{ $t('Disapproved') }}
          </button>
        <button
          type="button"
          class="btn w-100"
          :class="approval.status === 'approved' ? 'btn-success' : 'btn-outline-success'"
          @click="approval.status = 'approved'">
          <i class="far fa-thumbs-up"></i>
          {{ $t('Approved') }}
          </button>
      </div>
      <ValidateMessage
        :error="validateErrors.status" />
    </div>

    <button
      type="button"
      class="btn btn-primary"
      :disabled="!approval.status"
      @click="save">{{ $t('Send') }}</button>
  </div>

</template>

<script>
export default {
  name: 'ApprovalflowResponse',
  components: {
  },
  props: {
    approvalflowId: {
      type: String
    }
  },
  data () {
    return {
      loading: false,
      approval: {
        comment: '',
        status: null
      },
      validateErrors: {}
    }
  },
  computed: {
  },
  created () {
  },
  methods: {
    save () {
      this.loading = true
      return this.$store.dispatch('createApprovalflowResponse', {
        _id: this.approvalflowId,
        status: this.approval.status,
        comment: this.approval.comment
      }).then(result => {
        this.$emit('saved')
      }).catch((err) => {
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Approvalflow/ApprovalflowResponse.vue